// import classNames from 'classnames';

import { Section, SectionContainer } from '@components/Section';
import Column from '@components/Column/Column';
import Img from '@components/Img';

import Styles from './Styles.module.scss';

const EnterpriseFutureOfWork = ({ className, style }) => {
  return (
    <SectionContainer anchor='future-of-work' className={Styles.container} style={style}>
      <Section
        textColor={Section.Color.WHITE}
        title='Join the Future of Work With the Best Talent in Digital'>
        <Column.List isCardList>
          <Column.Card>
            <Column.Image type={Column.Image.Type.ICON}>
              <Img
                className={Styles.image}
                height={75}
                width={75}
                title='on demand teams'
                alt='on demand teams'
                src={`/img/enterprise/on-demand.svg`}
              />
            </Column.Image>
            <Column.Headline>{'On Demand Teams'}</Column.Headline>
            <Column.Content>
              {`A fully vetted team with the skills and infrastructure needed to complete custom projects.`}
            </Column.Content>
          </Column.Card>
          <Column.Card>
            <Column.Image type={Column.Image.Type.ICON}>
              <Img
                className={Styles.image}
                height={75}
                width={75}
                title='ongoing engagements'
                alt='ongoing engagements'
                src={`/img/enterprise/individual-engagement.svg`}
              />
            </Column.Image>
            <Column.Headline>{'Ongoing Engagements'}</Column.Headline>
            <Column.Content>
              {`Kickstart talent engagements within the organization, tailored to complement existing resources.`}
            </Column.Content>
          </Column.Card>
          <Column.Card>
            <Column.Image type={Column.Image.Type.ICON}>
              <Img
                className={Styles.image}
                height={75}
                width={75}
                title='project-based engagements'
                alt='project-based engagements'
                src={`/img/enterprise/multiple-engagement.svg`}
              />
            </Column.Image>
            <Column.Headline>{'Project-Based Engagements'}</Column.Headline>
            <Column.Content>
              {`Work with skilled individuals to fulfil your requirements for standalone projects.`}
            </Column.Content>
          </Column.Card>
        </Column.List>
      </Section>
    </SectionContainer>
  );
};

export default EnterpriseFutureOfWork;
